import gsap from 'gsap'

import { Animation } from '@/types'

export const heroRevealAnimation = ({
  node,
  context,
  conditions
}: Animation) => {
  if (conditions?.isSmall) return

  const selector = context?.selector || gsap.utils.selector(node)

  const timeline = gsap.timeline({
    defaults: { duration: 2, ease: 'power3.inOut' }
  })

  return () => {
    timeline?.kill()
  }
}
